//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    resultName: {
      type: String,
      default: ''
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    resultMeasurementUnit: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    }
  },
  computed: {
    numberValue: {
      get: function () {
        return this.resultValue.value
      },
      set: function (value) {
        if (value === '') {
          value = null
        }
        this.$set(this.resultValue, 'value', value)
      }
    }
  }
}

